import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from "../../Button";
import DropdownMenu from "../../DropdownMenu";
const months = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
const DatePickerMonths = ({ selectedMonth, setSelectedMonth }) => {
    return (_jsxs(DropdownMenu, { children: [_jsx(DropdownMenu.Trigger, { asChild: true, children: _jsx(Button, { variant: "outlined", color: "default", children: months[selectedMonth] }) }), _jsx(DropdownMenu.Content, { align: "start", portal: false, children: months.map((month, index) => (_jsx(DropdownMenu.Item, { onClick: () => setSelectedMonth(index), children: month }, month))) })] }));
};
export default DatePickerMonths;
